import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { useSingleImageUrl } from '@blaze-cms/image-cdn-react';
const {
  SOCIAL_META_IMAGE_KEY,
  IMAGE_URL_KEY,
  IMAGE_CONTENT_URL_KEY
} = require('../constants');
const StructuredDataHeader = ({
  structuredDataJsonLd,
  addNoArchiveHeader
}) => {
  const image = structuredDataJsonLd.image || {};
  const {
    [IMAGE_URL_KEY]: imageUrl,
    [IMAGE_CONTENT_URL_KEY]: contentUrl
  } = image;
  const convertedImageUrl = useSingleImageUrl({
    src: imageUrl,
    sizeKey: SOCIAL_META_IMAGE_KEY
  });
  const convertedContentUrl = useSingleImageUrl({
    src: contentUrl,
    sizeKey: SOCIAL_META_IMAGE_KEY
  });
  if (!structuredDataJsonLd) return null;
  const processedStructuredDataJsonLd = _objectSpread({}, structuredDataJsonLd);
  if (imageUrl) {
    processedStructuredDataJsonLd.image = _objectSpread(_objectSpread({}, processedStructuredDataJsonLd.image), {}, {
      [IMAGE_URL_KEY]: convertedImageUrl
    });
  }
  if (convertedContentUrl) {
    processedStructuredDataJsonLd.image = _objectSpread(_objectSpread({}, processedStructuredDataJsonLd.image), {}, {
      [IMAGE_CONTENT_URL_KEY]: convertedContentUrl
    });
  }
  return /*#__PURE__*/React.createElement(Head, null, structuredDataJsonLd && /*#__PURE__*/React.createElement("script", {
    key: "structuredDataJsonLd",
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(processedStructuredDataJsonLd)
    }
  }), addNoArchiveHeader && /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: "noarchive"
  }));
};
StructuredDataHeader.propTypes = {
  addNoArchiveHeader: PropTypes.bool.isRequired,
  structuredDataJsonLd: PropTypes.object.isRequired
};
export default StructuredDataHeader;
//# sourceMappingURL=StructuredDataHeader.js.map